import Client from './Clients/ScrapingToolsClient'
import RepoUtils from './RepoUtils'

const resource = '/outputs/popularity_site/'
const tableResource = '/outputs/popularity_site_table/'
const autocompleteResource = '/outputs/popularity_site/autocomplete/'

export default {
    get(){
        return Client.get(resource);
    },
    getWithId(id){
        return Client.get(resource+'?id='+id);
    },
    getTable(pageNumber,filters){
        filters.page=pageNumber;
        return Client.get(RepoUtils.parseResourceWithQueryParams(tableResource,filters));
    },
    autocomplete(payload){
        return Client.post(autocompleteResource,payload);
    },
    post(payload){
        return Client.post(resource,payload);
    },
    put(id,payload){
        return Client.put(`${resource}${id}/`,payload);
    }
}